<template lang="html">
  <div class="convenience" id="teste">

    <div class="container">
      <div class="row"> <!-- Titulo -->
        <h2 class="title">{{$t('telas.comodidades.titulo')}}</h2>
      </div>

      <div class="row comodidade-row row1">

        <!-- Internet -->
        <div class="col-md-3 col-lg-3 div-item-comodidade">
          <div class="content-card">
            <div class="title-card">
              <p><img src="../../assets/png/glyphicons-74-wifi.png" class="png-icons-convenience" alt="Wi-Fi"> 
                {{$t('telas.comodidades.descricao.internet.titulo')}}
              </p>
            </div>
            <table class="table table-striped">
              <tbody>
                <tr>
                  <th scope="row">{{$t('telas.comodidades.descricao.internet.d1')}}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Animais -->
        <div class="col-md-3 col-lg-3 div-item-comodidade">
          <div class="content-card">
            <div class="title-card">
              <p><img src="../../assets/png/glyphicons-542-cat.png" class="png-icons-convenience" alt="Animais"> 
                {{$t('telas.comodidades.descricao.animais.titulo')}}
              </p>
            </div>
            <table class="table table-striped">
              <tbody>
                <tr>
                  <th scope="row">{{$t('telas.comodidades.descricao.animais.d1')}}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Atividades -->
        <div class="col-md-3 col-lg-3 div-item-comodidade">
          <div class="content-card">
            <div class="title-card">
              <p><img src="../../assets/png/glyphicons-307-bicycle.png" class="png-icons-convenience" alt="Atividades"> 
                {{$t('telas.comodidades.descricao.atividades.titulo')}}
              </p>
            </div>
            <table class="table table-striped">
              <tbody>
                <tr>
                  <th scope="row">{{$t('telas.comodidades.descricao.atividades.d1')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.atividades.d2')}}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Estacionamento -->
        <div class="col-md-3 col-lg-3 div-item-comodidade">
          <div class="content-card">
            <div class="title-card">
              <p><img src="../../assets/png/glyphicons-720-parking.png" class="png-icons-convenience" alt="Estacionamento"> 
                {{$t('telas.comodidades.descricao.estacionamento.titulo')}}</th>
              </p>
            </div>
            <table class="table table-striped">
              <tbody>
                <tr>
                  <th scope="row">{{$t('telas.comodidades.descricao.estacionamento.d1')}}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div> <!-- Row -->

      <div class="row comodidade-row">

        <!-- Áreas ao ar livre -->
        <div class="col-md-3 col-lg-3 div-item-comodidade">
          <div class="content-card">
            <div class="title-card">
              <p><img src="../../assets/png/glyphicons-14-beach-umbrella.png" class="png-icons-convenience" alt="Ar livre"> 
                {{$t('telas.comodidades.descricao.jardim.titulo')}}
              </p>
            </div>
            <table class="table table-striped">
              <tbody>
                <tr>
                  <th scope="row">{{$t('telas.comodidades.descricao.jardim.d1')}}</th>
                </tr>
                <tr>
                  <th scope="row">{{$t('telas.comodidades.descricao.jardim.d2')}}</th>
                </tr>
                <tr>
                  <th scope="row">{{$t('telas.comodidades.descricao.jardim.d3')}}</th>
                </tr>
                <tr>
                  <th scope="row">{{$t('telas.comodidades.descricao.jardim.d4')}}</th>
                </tr>
                <tr>
                  <th scope="row">{{$t('telas.comodidades.descricao.jardim.d5')}}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Entretenimento -->
        <div class="col-md-3 col-lg-3 div-item-comodidade">
          <div class="content-card">
            <div class="title-card">
              <p><img src="../../assets/png/glyphicons-87-display.png" class="png-icons-convenience" alt="Entretenimento"> 
                {{$t('telas.comodidades.descricao.entretenimento.titulo')}}
              </p>
            </div>
            <table class="table table-striped">
              <tbody>
                <tr>
                  <th scope="row">{{$t('telas.comodidades.descricao.entretenimento.d1')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.entretenimento.d2')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.entretenimento.d3')}}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Restaurante -->
        <div class="col-md-3 col-lg-3 div-item-comodidade">
          <div class="content-card">
            <div class="title-card">
              <p><img src="../../assets/png/glyphicons-277-cutlery.png" class="png-icons-convenience" alt="Restaurante"> 
                {{$t('telas.comodidades.descricao.restaurante.titulo')}}
              </p>
            </div>
            <table class="table table-striped">
              <tbody>
                <tr>
                  <th scope="row">{{$t('telas.comodidades.descricao.restaurante.d1')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.restaurante.d2')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.restaurante.d4')}}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Geral -->
        <div class="col-md-3 col-lg-3 div-item-comodidade">
          <div class="content-card">
            <div class="title-card">
              <p><img src="../../assets/png/glyphicons-341-globe.png" class="png-icons-convenience" alt="Geral"> 
                {{$t('telas.comodidades.descricao.geral.titulo')}}
              </p>
            </div>
            <table class="table table-striped">
              <tbody>
                <tr>
                  <th scope="row">{{$t('telas.comodidades.descricao.geral.d1')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.geral.d2')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.geral.d3')}}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div> <!-- Row -->

      <div class="row comodidade-row">

        <!-- Serviços -->
        <div class="col-md-3 col-lg-3 div-item-comodidade">
          <div class="content-card">
            <div class="title-card">
              <p><img src="../../assets/png/glyphicons-477-plate-of-food.png" class="png-icons-convenience" alt="Geral"> 
                {{$t('telas.comodidades.descricao.servicos.titulo')}}
              </p>
            </div>
            <table class="table table-striped">
              <tbody>
                <tr>
                  <th scope="row">{{$t('telas.comodidades.descricao.servicos.d2')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.servicos.d3')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.servicos.d4')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.servicos.d5')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.servicos.d6')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.servicos.d7')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.servicos.d8')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.servicos.d9')}}</th>
                </tr>
                <tr>
                  <th>{{$t('telas.comodidades.descricao.servicos.d10')}}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div> <!-- Row -->

      <!-- reserva -->
      <reserva :header="true"></reserva>

    </div> <!-- Container -->
  </div>
</template>

<script>
import reserva from '../../components/reservation-component/ReservationComponent'

export default {
  name: 'Convenience',

  components: {
    reserva
  },
}
</script>

<style lang="css">
.convenience {
  background-image: url('../../assets/img/bg.png');
  background-repeat: repeat;
  font-family: 'Quicksand', sans-serif;
  padding-bottom: 80px;
  padding-top: 100px;
}
.convenience .container .row h2.title {
  width: 100%;
  text-align: center;
  color: rgb(118, 106, 49);
  margin-bottom: 40px;
}

.convenience .container .comodidade-row {
  margin-top: 10px;
}
.convenience .container .comodidade-row .div-item-comodidade {
  margin-bottom: 20px;
}
.convenience .container .row div.content-card {
  padding: 5px;
  background-color: rgb(23, 162, 184);
  border-radius: 5px;
}
.convenience .container .row div.content-card div.title-card p {
  text-align: center;
  color: white
}
.convenience .container .row div.content-card div.title-card img.png-icons-convenience {
  margin-right: 5px;
  filter: invert(100%);
  height: 20px;
}

.convenience .container .row div.content-card table.table tbody tr {
  cursor: pointer;
  color: white;
  transition: all 0.5s;
}
.convenience .container .row div.content-card table.table tbody tr:HOVER {
  box-shadow: 3px 1px 3px #666
}
</style>



// WEBPACK FOOTER //
// src/pages/convenience/Convenience.vue